import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/etb/enrollment-report";
const API_PATH_EXCEL = ConstantList.API_ENPOINT + "/api/etb/download-file";

export const reportOnDetectingDrugResistantTbPatients = (searchObject) => {
  var url = API_PATH + "/view-report-enrollment-location";
  return axios.post(url, searchObject);
};
export const reportPreliminaryReportOnDetectingDrugResistantTbPatients = (obj) => {
  let url = API_PATH_EXCEL + "/export-report-enrollment-location";
  return axios({
    url: url,
    method: "POST",
    responseType: "blob",
    data: obj,
  });
}
// export const exportimportDetectionReport = (obj) => {
//   let url = API_PATH_EXCEL + "/exportimportDetectionReport";
//   return axios({
//     url: url,
//     method: "POST",
//     responseType: "blob",
//     data: obj,
//   });
// }

export const getPagePatientDetectionReport = (searchObject) => {
  var url = API_PATH + "/view-patient-detection-report";
  return axios.post(url, searchObject);
};

// export const importExcel = (file) => {
//     const url = API_PATH_EXCEL + "/importDetectionReport";
//     let formData = new FormData();
//     formData.append("uploadfile", file); //Lưu ý tên 'uploadfile' phải trùng với tham số bên Server side
//     // const config = {
//     //     headers: {
//     //         "Content-Type": "multipart/form-data",
//     //     },
//     // };
//     // return axios.post(url, formData, config);
//     return axios({
//       url: url,
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//       method: "POST",
//       responseType: "blob",
//       data: formData,
//     });
// }
